module.exports = __webpack_public_path__ + "img/201612-3-768x1024.44cdf1f2.jpg";